import sha256 from "crypto-js/sha256";
import Base64 from "crypto-js/enc-base64";
import jwt from "jsonwebtoken";
import { AuthConsts } from "../consts/AuthConsts";

export const UOM_ROLE_ADMIN = "Admin";
export const UOM_ROLE_IT = "IT";
export const UOM_ROLE_BUSINESS = "Business";
export const UOM_ROLE = "uom_role";

export const IsAuthorized = () => {
  return TokenExist() && IsValidJwtToken() && !IsTokenExpired();
};

export const TokenExist = () =>
  window.sessionStorage.getItem("user") &&
  JSON.parse(window.sessionStorage.getItem("user")).jwtToken;

export const IsValidJwtToken = () =>
  window.sessionStorage.getItem("user") &&
  jwt.decode(JSON.parse(window.sessionStorage.getItem("user")).jwtToken);

export const IsTokenExpired = () =>
  window.sessionStorage.getItem("user") &&
  JSON.parse(window.sessionStorage.getItem("user")).jwtTokenExpiration * 1000 <
    Date.now();

export const GetBase64Url = (string) => {
  return string
    .toString(Base64)
    .replace(/=/g, "")
    .replace(/\+/g, "-")
    .replace(/\//g, "_");
};

export const GenerateCodeVerifier = () => {
  const length = 128;
  const randomValues = new Uint8Array(length);
  crypto.getRandomValues(randomValues);
  const possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
  let text = "";
  for (let i = 0; i < length; i++) {
    text += possible.charAt(randomValues[i] % possible.length);
  }
  return text;
};

export const GenerateCodeChallenge = (codeVerifier) => {
  return GetBase64Url(sha256(codeVerifier));
};

export const GetAccessToken = () => {
  if (IsAuthorized())
    return JSON.parse(window.sessionStorage.getItem("user")).jwtToken;

  return null;
};

export const GetUser = () => {
  if (IsAuthorized())
    return jwt.decode(
      JSON.parse(window.sessionStorage.getItem("user")).jwtToken
    );

  return null;
};

export const GetRole = () => {
  if (IsAuthorized())
    return JSON.parse(window.sessionStorage.getItem("user")).role;

  return null;
};

/*export const isAdmin = () => {
    return GetUser().feature.indexOf("PORTAL_UOM_ADMIN") > 0;
    //return 1 == 1;
}*/

export const hasClaim = (claimType, claimName) => {
  return true;

  //if (GetUser()[claimType] !== undefined)
  //    return GetUser()[claimType] === claimName;
  //else
  //    return false;
};

export const CanWrite = () =>
  GetRole().roleCode === AuthConsts.Roles.Operator ||
  GetRole().roleCode === AuthConsts.Roles.Operator_Advanced ||
  GetRole().roleCode === AuthConsts.Roles.Operator_Supervisor;

export const hasRoleAccess = (pageRoles) => {
  const role = GetRole();
  // return roles.filter((r) => pageRoles.includes(r)).length > 0;
  return pageRoles.includes(role);
};
